export const apiHost = `https://essilor.crm3d.ru/api`;
// export const apiHost = `https://crm.essilor-pro.ru/api`;
export const host = `https://essilor.crm3d.ru/`;
// export const host = `https://crm.essilor-pro.ru/`;
